import loadable from '@loadable/component';

import { handleChunkLoadError } from '../../../../../utils/loadable';

export const ActionsCentersLoadable = loadable(
  () => import('./ActionsCenters').catch(/* istanbul ignore next */ handleChunkLoadError('ActionsCenters')),
  { ssr: false },
);
